/** What the matter turns on (answer anatomy 02): short cards written from no side, no lean glyphs. */
export function TurnsOn({ items }: { items: { label: string; question: string }[] }) {
  return (
    <ul className="aturns" aria-label="What this turns on">
      {items.map((it, i) => (
        <li key={i}>
          <span className="t">{it.label}</span>
          <span className="q">{it.question}</span>
        </li>
      ))}
    </ul>
  )
}
